import { Injectable } from '@angular/core';
import { LocalUser } from '../../domain/models/local-user.model';
import { LocalUserCreateInput } from '../../domain/models/local-user-create-input.model';
import { isManagedRole } from '../../domain/models/local-user-role.model';
import { LocalUserUpdateInput } from '../../domain/models/local-user-update-input.model';
import { LocalClientDto } from '../dtos/local-client.dto';
import { CreateLocalClientPayload, UpdateLocalClientPayload } from '../datasources/remote/local-users.remote-datasource';

@Injectable()
export class LocalUserMapper {
  public toLocalUser(dto: LocalClientDto): LocalUser | null {
    if (dto.AccountRealm !== 'administration' || !dto.Role || !isManagedRole(dto.Role)) return null;

    return {
      id: dto.ClientId,
      publicId: dto.PublicId,
      username: dto.Username,
      firstName: dto.FirstName ?? '',
      lastName: dto.LastName ?? '',
      role: dto.Role,
      departmentId: dto.DepartmentId,
      isActive: dto.IsActive,
      createdAt: dto.CreatedAt,
      avatarUrl: dto.AvatarUrl,
      linkedProviderUserExternalId: dto.ProviderUserExternalId,
      departmentName: dto.SedeName,
      invitationPending: dto.InvitationPending,
      invitationDeliveryFailed: dto.InvitationDeliveryFailed,
    };
  }

  public toCreatePayload(input: LocalUserCreateInput): CreateLocalClientPayload {
    return {
      Username: input.username,
      // Omitted entirely (never sent as an empty string) when not supplied, so the backend takes
      // the invitation branch -- CreateLocalClientPayload.Password is optional for exactly this.
      ...(input.password ? { Password: input.password } : {}),
      FirstName: input.firstName,
      LastName: input.lastName,
      RoleId: input.roleId,
      DepartmentId: input.departmentId,
      LinkedProviderUserExternalId: input.linkedProviderUserExternalId ?? null,
    };
  }

  public toUpdatePayload(input: LocalUserUpdateInput): UpdateLocalClientPayload {
    return {
      Username: input.username,
      Password: input.password ? input.password : null,
      FirstName: input.firstName,
      LastName: input.lastName,
      RoleId: input.roleId,
      DepartmentId: input.departmentId,
      IsActive: input.isActive,
    };
  }
}
